import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-investment-successful-modal",
  templateUrl: "./investment-successful-modal.component.html",
  styleUrls: ["./investment-successful-modal.component.scss"],
  standalone: false,
})
export class InvestmentSuccessfulModalComponent {
  constructor(
    public dialogRef: MatDialogRef<InvestmentSuccessfulModalComponent>
  ) {}

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }
}
